export default function getOptionPriceDescription(
  option,
  checked,
  options,
  showCampaignPrice,
  isDealerConfigurator,
  lang,
  order,
  strings
) {
  if (isDealerConfigurator) {
    return ''
  }

  let price = null
  let originalPrice = null
  let description_override = ''

  if (checked == option.id) {
    if (order.paymentType === 'cash' && option?.min_price !== undefined) {
      if (showCampaignPrice && option?.min_original_price !== undefined) {
        originalPrice = option.min_original_price
      }

      price = option.min_price ?? 0
    } else if (order.paymentType === 'leasing' && option?.min_leasing_price !== undefined) {
      price = option?.min_leasing_price ?? 0
    }
  } else {
    const notCheckedOption = options.find(_option => _option.id == option.id)
    const checkedOption = options.find(_option => _option.id == checked)

    if (notCheckedOption === undefined || checkedOption === undefined) {
      return ''
    }

    if (order.paymentType === 'cash' && notCheckedOption?.min_price !== undefined && checkedOption?.min_price !== undefined) {
      price = (notCheckedOption.min_price ?? 0) - (checkedOption.min_price ?? 0)
    } else if (order.paymentType === 'leasing' && notCheckedOption?.min_leasing_price !== undefined && checkedOption?.min_leasing_price !== undefined) {
      price = (notCheckedOption.min_leasing_price ?? 0) - (checkedOption.min_leasing_price ?? 0)
    }
  }

  if (price === null) {
    return ''
  }

  if (originalPrice === price) {
    originalPrice = null
  }

  const prices = [originalPrice, price].filter((_price) => _price !== null)

  prices.forEach((_price, index) => {
    if (index === 0 && prices.length > 1) {
      description_override += '<span style="text-decoration: line-through; opacity: 0.5;">'
    } else {
      description_override += '<span>'
    }

    if (checked == option.id) {
      description_override += order.paymentType === 'leasing' ? strings.misc.from + ' ' : ''
    } else {
      description_override = _price >= 0 ? '+' : ''
    }

    description_override += new Intl.NumberFormat(lang).format(_price)
    description_override += ' '
    description_override += order.paymentType === 'leasing' ? strings.price.formats.leasing : strings.price.formats.cash

    description_override += '</span>'
  })

  return description_override
}
